import { instanceOfProductImageFormat } from './instanceOfProductImageFormat';
import { ProductImage } from './ProductImage';

export function instanceOfProductImage (object: any): object is ProductImage {
  return object.big &&
    object.desktop &&
    object.mobile &&
    object.alt &&
    instanceOfProductImageFormat(object.big) &&
    instanceOfProductImageFormat(object.mobile) &&
    instanceOfProductImageFormat(object.mobile);
}
